import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

import EnhancedForgotPasswordForm from "./EnhancedForgotPassword";

import styles from "assets/jss/material-kit-react/views/loginPage.js";
import GridContainer from "components/MaterialKit/Grid/GridContainer.js";
import GridItem from "components/MaterialKit/Grid/GridItem.js";

import Card from "components/MaterialKit/Card/Card.js";
const useStyles = makeStyles(styles);

const ForgotPassword = ({ setOpenModal }) => {
  const classes = useStyles();
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  return (
    <div className={classes.container}>
      <GridContainer
        justify="center"
        style={{ flexDirection: "row", alignItems: "center" }}
      >
        <GridItem xs={12} sm={12} md={6}>
          <Card className={classes[cardAnimaton]}>
            <EnhancedForgotPasswordForm setOpenModal={setOpenModal} />
            <br />
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default ForgotPassword;
